// import { Member } from '@hiwaldo/sdk/interfaces';
import { getFromLocalStorage } from '../../../../utils';
import { LocalStorageKeys } from '../../../../enums/local-storage-keys';

export interface MemberState {
  member: any | null; // Member | null;
  authedId: number | null;
  loggedIn: boolean;
  loading: boolean;
  error?: string;
}

export const initialMemberState: MemberState = getFromLocalStorage(
  LocalStorageKeys.MEMBER_STATE,
  {
    member: null,
    authedId: null,
    loggedIn: false,
    error: '',
    loading: false,
  }
);
